import { render, staticRenderFns } from "./hosting_component.vue?vue&type=template&id=36521172&scoped=true&"
import script from "./hosting_component.vue?vue&type=script&lang=js&"
export * from "./hosting_component.vue?vue&type=script&lang=js&"
import style0 from "./hosting_component.vue?vue&type=style&index=0&id=36521172&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36521172",
  null
  
)

export default component.exports